export type QuestionType = "rating" | "multiple_choice" | "text" | "yes_no";

export interface SurveyQuestion {
  id: string;
  text: string;
  type: QuestionType;
  options?: string[];
  required: boolean;
}

export interface Survey {
  id: string;
  title: string;
  description: string;
  questions: SurveyQuestion[];
  active: boolean;
  createdAt: string;
  responseCount: number;
}

export const surveys: Survey[] = [
  {
    id: "srvy-001",
    title: "Müşteri Memnuniyet Anketi",
    description: "Randevu sonrası genel memnuniyet değerlendirmesi",
    active: true,
    createdAt: "2026-04-01",
    responseCount: 45,
    questions: [
      {
        id: "q-001",
        text: "Hizmetimizden ne kadar memnun kaldınız?",
        type: "rating",
        required: true,
      },
      {
        id: "q-002",
        text: "Personelimizin davranışı nasıldı?",
        type: "rating",
        required: true,
      },
      {
        id: "q-003",
        text: "Hangi hizmeti aldınız?",
        type: "multiple_choice",
        required: true,
        options: ["Masaj", "Spa", "Cilt Bakımı", "Kese Köpük", "Sauna"],
      },
      {
        id: "q-004",
        text: "Bize öneride bulunmak ister misiniz?",
        type: "text",
        required: false,
      },
      {
        id: "q-005",
        text: "Tekrar ziyaret edecek misiniz?",
        type: "yes_no",
        required: true,
      },
    ],
  },
  {
    id: "srvy-002",
    title: "Paket Memnuniyet Anketi",
    description: "Paket kullanım süreci değerlendirmesi",
    active: true,
    createdAt: "2026-03-15",
    responseCount: 28,
    questions: [
      {
        id: "q-006",
        text: "Paket fiyatı uygun muydu?",
        type: "rating",
        required: true,
      },
      {
        id: "q-007",
        text: "Seans randevularınız kolay mı alındı?",
        type: "yes_no",
        required: true,
      },
      {
        id: "q-008",
        text: "Sonraki seanslar için hangi günler tercih edersiniz?",
        type: "multiple_choice",
        required: false,
        options: ["Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi", "Pazar"],
      },
    ],
  },
  {
    id: "srvy-003",
    title: "Hizmet Kalitesi Anketi",
    description: "Haftalık iç denetim değerlendirmesi",
    active: false,
    createdAt: "2026-02-20",
    responseCount: 12,
    questions: [
      {
        id: "q-009",
        text: "Ortam temizliği nasıldı?",
        type: "rating",
        required: true,
      },
      {
        id: "q-010",
        text: "Malzeme stok durumu yeterli miydi?",
        type: "yes_no",
        required: true,
      },
      {
        id: "q-011",
        text: "Notunuz",
        type: "text",
        required: false,
      },
    ],
  },
];